module.exports = __webpack_public_path__ + "pc/img/rec_12.5277d59c.svg";